import { State } from '../../types';

export const michigan: State = {
  name: 'Michigan',
  abbreviation: 'MI',
  terms: [
    {
      word: 'Allouez',
      phonetic: 'alla way',
      // audioUrl: '/audio/allouez.mp3',
      description: 'A village in Keweenaw County.'
    },
    {
      word: 'Au Gres',
      phonetic: 'aw gray',
      // audioUrl: '/audio/au_gres.mp3',
      description: 'A city in Arenac County.'
    },
    {
      word: 'Bete Grise',
      phonetic: 'bay-de-gree',
      // audioUrl: '/audio/bete_grise.mp3',
      description: 'A community in Keweenaw County.'
    },
    {
      word: 'Bois Blanc',
      phonetic: 'boy blonk',
      // audioUrl: '/audio/bois_blanc.mp3',
      description: 'An island in Lake Huron.'
    },
    {
      word: 'Charlevoix',
      phonetic: 'shar luh voy',
      // audioUrl: '/audio/charlevoix.mp3',
      description: 'A city in northern Michigan.'
    },
    {
      word: 'Charlotte',
      phonetic: 'shar lott',
      // audioUrl: '/audio/charlotte.mp3',
      description: 'A city in Eaton County.'
    },
    {
      word: 'Dowagiac',
      phonetic: 'doh wah zhee ack',
      // audioUrl: '/audio/dowagiac.mp3',
      description: 'A city in Cass County.'
    },
    {
      word: 'Epoufette',
      phonetic: 'ep oo fett',
      // audioUrl: '/audio/epoufette.mp3',
      description: 'A community in Mackinac County.'
    },
    {
      word: 'Gratiot',
      phonetic: 'grash it',
      // audioUrl: '/audio/gratiot.mp3',
      description: 'A county in central Michigan.'
    },
    {
      word: 'Grosse Ile',
      phonetic: 'gross eel',
      // audioUrl: '/audio/grosse_ile.mp3',
      description: 'An island township in Wayne County.'
    },
    {
      word: 'Hamtramck',
      phonetic: 'ham tram ick',
      // audioUrl: '/audio/hamtramck.mp3',
      description: 'A city surrounded by Detroit.'
    },
    {
      word: 'Keweenaw',
      phonetic: 'kee wen aw',
      // audioUrl: '/audio/keweenaw.mp3',
      description: 'A county in the Upper Peninsula.'
    },
    {
      word: 'Kitchitikipi',
      phonetic: 'kitch itty kip py',
      // audioUrl: '/audio/kitchitikipi.mp3',
      description: 'A spring in Palms Book State Park.'
    },
    {
      word: 'Lake Gogebic',
      phonetic: 'lake go gee bick',
      // audioUrl: '/audio/lake_gogebic.mp3',
      description: 'A large inland lake in the Upper Peninsula.'
    },
    {
      word: 'Lake Orion',
      phonetic: 'lake oh ree an',
      // audioUrl: '/audio/lake_orion.mp3',
      description: 'A village in Oakland County.'
    },
    {
      word: 'Mackinac',
      phonetic: 'MAK-in-aw',
      // audioUrl: '/audio/mackinac.mp3',
      description: 'Island and bridge in northern Michigan'
    },
    {
      word: 'Milan',
      phonetic: 'my linn',
      // audioUrl: '/audio/milan.mp3',
      description: 'A city in Monroe and Washtenaw counties.'
    },
    {
      word: 'Neebish Island',
      phonetic: 'nee bish',
      // audioUrl: '/audio/neebish_island.mp3',
      description: 'An island in the St. Marys River.'
    },
    {
      word: 'Ocqueoc',
      phonetic: 'ock key ock',
      // audioUrl: '/audio/ocqueoc.mp3',
      description: 'A township in Presque Isle County.'
    },
    {
      word: 'Okemos',
      phonetic: 'oh kuh muss',
      // audioUrl: '/audio/okemos.mp3',
      description: 'A census-designated place in Ingham County.'
    },
    {
      word: 'Onekama',
      phonetic: 'oh neck em uh',
      // audioUrl: '/audio/onekama.mp3',
      description: 'A village in Manistee County.'
    },
    {
      word: 'Onondaga',
      phonetic: 'onnin day ga',
      // audioUrl: '/audio/onondaga.mp3',
      description: 'A township in Ingham County.'
    },
    {
      word: 'Ontonagon',
      phonetic: 'ontin noggin',
      // audioUrl: '/audio/ontonagon.mp3',
      description: 'A village in the Upper Peninsula.'
    },
    {
      word: 'Ossineke',
      phonetic: 'ossin eek',
      // audioUrl: '/audio/ossineke.mp3',
      description: 'A community in Alpena County.'
    },
    {
      word: 'Pointe Aux Barques',
      phonetic: 'point aw barks',
      // audioUrl: '/audio/pointe_aux_barques.mp3',
      description: 'A lighthouse in Huron County.'
    },
    {
      word: 'Pointe Aux Pins',
      phonetic: 'point aw pin',
      // audioUrl: '/audio/pointe_aux_pins.mp3',
      description: 'A community on Mackinac Island.'
    },
    {
      word: 'Ponshewaing',
      phonetic: 'pon sha wayng',
      // audioUrl: '/audio/ponshewaing.mp3',
      description: 'A community in Emmet County.'
    },
    {
      word: 'Presque Isle',
      phonetic: 'presk eel',
      // audioUrl: '/audio/presque_isle.mp3',
      description: 'A county in the Lower Peninsula.'
    },
    {
      word: 'Quinnesec',
      phonetic: 'kwinn eh seck',
      // audioUrl: '/audio/quinnesec.mp3',
      description: 'A community in Dickinson County.'
    },
    {
      word: 'Sault Ste. Marie',
      phonetic: 'sue saint marie',
      // audioUrl: '/audio/sault_ste_marie.mp3',
      description: 'A city in the Upper Peninsula.'
    },
    {
      word: 'Sebewaing',
      phonetic: 'see-buh-wing',
      // audioUrl: '/audio/sebewaing.mp3',
      description: 'A village in Huron County, known for its Sugar Festival and proximity to Saginaw Bay.'
    },
    {
      word: 'Zeeland',
      phonetic: 'zee-luhnd',
      // audioUrl: '/audio/zeeland.mp3',
      description: 'A city in Ottawa County, named after the Dutch province of Zeeland.'
    }
  ]
};
